import { FC } from "react";

export const Caption: FC<{ children?: React.ReactNode }> = ({ children }) => (
  <div className={"subtle text-xs"}>{children}</div>
);
